(function () {

  const products_block__wrapper = document.querySelector('.js_products_block__wrapper')

  if (products_block__wrapper) {
    breakTitle(products_block__wrapper);
    handleEqualHeightOnContentElements(products_block__wrapper);
  }

  function handleEqualHeightOnContentElements(products__wrapper) {

    const _contents = products__wrapper.querySelectorAll('.product-content');

    if (window.innerWidth > 767) {
      setEqualHeightOnContentElements(_contents);

      window.addEventListener('resize', () => setEqualHeightOnContentElements(_contents));
    }
    else {
      _contents.forEach((content) => {
        content.children[0].style.height = 'initial';
        content.children[1].style.height = 'initial';
      });
    }
  }

  function setEqualHeightOnContentElements(contents) {

    if (contents) {

      let _titleMaxHeight = 0;
      let _textMaxHeight = 0;

      contents.forEach((content) => {
        content.children[1].style.height = ''; // Reset the height before calculating

        _titleMaxHeight = getElementMaxHeight(content.children[0].children[0], _titleMaxHeight);
        _textMaxHeight = getElementMaxHeight(content.children[1], _textMaxHeight);
      });

      contents.forEach((content) => {
        content.children[0].style.height = _titleMaxHeight + 'px';
        content.children[1].style.height = _textMaxHeight + 'px';
      });

    }
  }

  function getElementMaxHeight(el, elMaxHeight) {
    if (el.offsetHeight > elMaxHeight) {
      elMaxHeight = el.offsetHeight;
    }
    return elMaxHeight;
  }

  function breakTitle(products) {
    const productItems = products.querySelectorAll(".product-item--title a");

    productItems.forEach(item => {
      const originalHtmlTrimmed = item.innerHTML.replace(/^\s+/, '');
      const firstWord = originalHtmlTrimmed.split(' ')[0];
      const remainingContent = originalHtmlTrimmed.slice(firstWord.length);
      item.innerHTML = `${firstWord}</br>${remainingContent}`;
    });
  }

})()

